module.exports = __webpack_public_path__ + "static/autodidatismo-para-iniciantes-01bf0077335e7e8f2fe344ef26d08468.jpg";